import React from 'react';
import { Building2, Hammer, Trees, Drill, DoorOpen, Grid3x3 } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const gewerkeData = [
  {
    icon: Building2,
    title: 'Hochbau',
    description: 'Mauersteine, Beton, Zement, Mörtel, Bauchemie',
    examples: ['Kalksandstein KS', 'Porenbetonstein', 'Werksmörtel', 'Transportbeton'],
    color: '#8B1538'
  },
  {
    icon: Hammer,
    title: 'Ausbau',
    description: 'Trockenbau, Dämmstoffe, Gipsprodukte, Akustikplatten',
    examples: ['Gipskartonplatten', 'Mineralwolle', 'OSB-Platten', 'Rigips-Systeme'],
    color: '#6B6B6B'
  },
  {
    icon: Trees,
    title: 'Gala-Bau',
    description: 'Pflastersteine, Naturstein, Schotter, Erden',
    examples: ['Betonsteine', 'Granit-Platten', 'Kies & Splitt', 'Mutterboden'],
    color: '#8B1538'
  },
  {
    icon: Drill,
    title: 'Tiefbau',
    description: 'Kanalsysteme, Schächte, Fundamente, Drainagen',
    examples: ['Betonrohre', 'Revisionsschächte', 'Beton C25/30', 'Kanalrohre'],
    color: '#6B6B6B'
  },
  {
    icon: DoorOpen,
    title: 'Bauelemente',
    description: 'Fenster, Türen, Tore, Zargen, Beschläge',
    examples: ['Kunststofffenster', 'Haustüren', 'Innentüren', 'Garagentore'],
    color: '#8B1538'
  },
  {
    icon: Grid3x3,
    title: 'Fliesen',
    description: 'Wand- und Bodenfliesen, Naturstein, Verlegematerial',
    examples: ['Feinsteinzeug', 'Mosaik-Fliesen', 'Fliesenkleber', 'Fugenmörtel'],
    color: '#6B6B6B'
  }
];

export const GewerkeSection = () => {
  return (
    <section id="gewerke" className="py-20 lg:py-32 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-2 rounded-full bg-[#8B1538]/10 text-[#8B1538] text-sm font-semibold mb-4">
            Unser Sortiment
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Alle Gewerke aus einer Hand
          </h2>
          <p className="text-xl text-gray-600">
            Umfassendes Sortiment für alle Bereiche des Baugewerbes – von der Planung bis zur Fertigstellung
          </p>
        </div>

        {/* Gewerke Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {gewerkeData.map((gewerk, index) => {
            const Icon = gewerk.icon;
            return (
              <Card 
                key={index}
                className="group hover:shadow-2xl transition-all duration-300 border-2 border-gray-200 hover:border-[#8B1538] overflow-hidden"
              >
                <CardContent className="p-8">
                  {/* Icon */}
                  <div className="mb-6">
                    <div 
                      className="w-16 h-16 rounded-xl flex items-center justify-center transition-all duration-300 group-hover:scale-110"
                      style={{ backgroundColor: `${gewerk.color}15` }}
                    >
                      <Icon className="w-8 h-8" style={{ color: gewerk.color }} />
                    </div>
                  </div>

                  {/* Content */}
                  <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-[#8B1538] transition-colors">
                    {gewerk.title}
                  </h3>
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    {gewerk.description}
                  </p>

                  {/* Examples */}
                  <div className="space-y-2">
                    <div className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-3">
                      Beispiele:
                    </div>
                    <div className="flex flex-wrap gap-2">
                      {gewerk.examples.map((example, idx) => (
                        <span
                          key={idx}
                          className="inline-block px-3 py-1 text-sm bg-gray-100 text-gray-700 rounded-full hover:bg-[#8B1538]/10 hover:text-[#8B1538] transition-colors duration-200"
                        >
                          {example}
                        </span>
                      ))}
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <p className="text-lg text-gray-600 mb-6">
            Sie finden nicht, was Sie suchen? Kontaktieren Sie uns für individuelle Anfragen.
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('kontakt');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center px-8 py-4 bg-[#8B1538] hover:bg-[#6B0F2A] text-white font-semibold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105"
          >
            Individuelle Anfrage stellen
          </button>
        </div>
      </div>
    </section>
  );
};